import React from 'react';

/**
 * 处理数据源
 * @param rawData
 * @param order
 */
function handleRawData(rawData, order) {
  // 漏斗图开始渲染的位置
  let funnelRangeStart = 52;

  return order.reduce(
    (res, id, index) => {
      const funnelDataItem = rawData[id];

      if (!funnelDataItem) {
        // 未找到则跳过该项
        return res;
      } else {
        // order中首项的value作为计算映射基础值的基数，相当于把数值映射到 0-30 的区间上
        // funnelRange 中 funnelRangeStart 为漏斗最左侧开始的坐标，
        // 由于我们把数值做了映射，因此最右侧结束的坐标应为 funnelRangeStart + 30
        if (index === 0) {
          res.reflectBase = funnelDataItem.value || 30;
          // 漏斗图展示为区间，需要定义开始结束位置
          // 首项必须为 50 - 100
          res.list.push(
            Object.assign({}, funnelDataItem, {
              funnelRange: [funnelRangeStart, funnelRangeStart + 30],
              // 左侧底部图层结束坐标, 25 为 0-50 映射区间的中点，这样可以让左侧底板刚好渲染到漏斗图的中线上
              funnelMaskEnd: funnelRangeStart + 15,
            })
          );
        } else {
          // 非首项，根据 reflectBase 计算漏斗结束的位置：50 / reflectEnd = reflectBase / funnelDataItem.value
          let reflectEnd = (funnelDataItem.value * 30) / res.reflectBase;

          // 从 50 开始计算坐标
          reflectEnd = funnelRangeStart + Number(reflectEnd.toFixed(2));

          // 防止数据过大导致漏斗变为倒漏斗，规定最大值为funnelRangeStart + 25
          reflectEnd = reflectEnd > funnelRangeStart + 10 ? funnelRangeStart + 10 : reflectEnd;

          // 为了防止数据过小导致漏斗变成一条线，规定最小值为funnelRangeStart + 10
          reflectEnd =
            reflectEnd > funnelRangeStart + (index === 1 ? 7 : index === 2 ? 5 : 2)
              ? reflectEnd
              : funnelRangeStart + (index === 1 ? 7 : index === 2 ? 5 : 2);

          res.list.push(
            Object.assign({}, funnelDataItem, {
              funnelRange: [funnelRangeStart, reflectEnd],
              funnelMaskEnd: funnelRangeStart + 25,
            })
          );
        }

        return res;
      }
    },
    { reflectBase: 1, rangeEnd: funnelRangeStart === 32 ? 100 : 110, list: [] }
  );
}
/**
 * 处理转化率
 * @param data 该行的配置
 * @param funnelRatioMap 转化率映射处理map
 * @param rawData 原始数据
 * @param isGapLineLabel 是否是跨行展示label的转化率
 */
function handleTransformRatio(data, funnelRatioMap, rawData, isGapLineLabel) {
  let transformRatioItem = { name: '', value: '' };
  // 获取当前漏斗展示的指标id
  const id = data.id;
  const handler = funnelRatioMap[id];
  // 如果外部传入的转化率映射项为function，则执行
  if (typeof handler === 'function') {
    transformRatioItem = handler(data, id, rawData);
  } else {
    transformRatioItem = rawData[handler];
  }

  return `${transformRatioItem?.name || '转化率'}：${isGapLineLabel ? '' : '\n'}${(
    (transformRatioItem?.value || 0) * 100
  ).toFixed(2)}%`;
}

export { handleRawData, handleTransformRatio };
